import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/Index.vue'),
    },
    {
      path: '/how',
      name: 'How',
      component: () => import('@/views/how/Index.vue'),
    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: () => import('@/views/portfolio/Index.vue'),
    },
    {
      path: '/where',
      name: 'Where',
      component: () => import('@/views/where/Index.vue'),
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () => import('@/views/chat/Index.vue'),
    },
  ],
})
